// 该文件封装单文件中公用的方法，添加公用方法时请慎用，非全局使用的请不要加入，避免污染
import dic from '@/common/dic';
import configEnv from '@/config/index';
import { pathRewrite } from '@/common/utils';

export default {
  data() {
    return {

    };
  },
  computed: {
    
  },
  methods: {
    // 导出excel表格方法
    async exportData({ loadData, text, callback }) {
      // const res = await this.$http.getBlob(url, params);
      loadData((res) => {
        if (res.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(res, 'utf-8');
          reader.onload = () => {
            const resObj = JSON.parse(reader.result);
            if (resObj.success === false) {
              this.$Message.info(resObj.message || '下载错误');
              if (typeof callback == 'function') {
                callback();
              }
            }
          };
        } else if (res) {
          const downloadUrl = window.URL.createObjectURL(res);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = text ? `${text }.xlsx` : '下载.xlsx';
          document.body.appendChild(a);
          // $('body').append(a) // 修复firefox中无法触发click
          a.click();
          // $(a).remove()
          a.parentNode.removeChild(a);
          if (typeof callback == 'function') {
            callback();
          }
        } else {
          this.$Message.error('报表没有记录');
        }
      });
    },
    pathRewrite(url) {
      return `${configEnv.baseURL||''}${pathRewrite(configEnv.pathRewrite, url)}`;
    },
    // 触发指定父组件的事件
    // dispatch(componentName, eventName, params) {
    //   let parent = this.$parent || this.$root;
    //   let { name } = parent.$options;

    //   while (parent && (!name || name !== componentName)) {
    //     parent = parent.$parent;

    //     if (parent) {
    //       name = parent.$options.name;
    //     }
    //   }
    //   if (parent) {
    //     parent.$emit.apply(parent, [eventName].concat(params));
    //   }
    // },
    // 数据字典转换
    filter(name, value) {
      let text = '';
      // 如果数据字典存在该类型的数据
      if (name && dic[name] && typeof value !== 'undefined') {
        dic[name].forEach(item => {
          if (item.value.toString() === value.toString()) {
            text = item.label;
          }
        });
      } else {
        text = `数据字典(${ name })不存在`;
      }
      return text;
    },
    // 跳转到收银台支付
    async pay({
      orderNo,accountNo,
    }) {
      const {corpCode} = this.$store.state.user.userInfo;
      // const url = '/paycenter-charge/api/facade/order/pay';
      const url = '/paycenter-charge/api/worktable/order/pay';
      const params = {
        corpCode,
        accountNo,// 应用下单需要传该参数
        orderNo,
        returnUrl: `${window.location.origin}/app/orderRecord/Detail?orderNo=${orderNo}`,
      };
      const res = await this.$http.post(url,params);
      if (res.success) {
        // this.detail = res.data; 
        // window.location.href = res.data;
        if (res.data.orderStatus===5){
          // 0 元支付订购成功时，直接跳转支付结果页面
          this.$router.push({
            path: '/pay/payResult',
            query: {
              orderNo,
            },
          });
        } else if (res.data.cashierUrl) {
          // 有收银台地址时跳转到收银台
          // window.open(res.data.cashierUrl,'_blank');
          window.location.href =res.data.cashierUrl;
        } else {
          this.$Message.warning('支付失败');
        }
      } else {
        this.$Message.warning(res.message || '获取详情失败');
      }
    },
   
    // 生成操作
    // renderOperate(h, btn) {
    //     let renderBtn = []
    //     if (btn instanceof Array) {
    //         let DropdownItem = []
    //         btn.forEach((item, index) => {
    //             let title = item.title

    //             if (title instanceof Function) {
    //                 title = title()
    //             }
    //             DropdownItem.push(h("DropdownItem", { props: { name: index } }, title))
    //         })
    //         let title = h("span", ['操作', h('Icon', { props: { type: "ios-arrow-down" } })])
    //         renderBtn = h('Dropdown', {
    //             on: {
    //                 'on-click': (index) => {
    //                     if (typeof btn[index].on['click'] === 'function') {
    //                         btn[index].on['click']()
    //                     }
    //                 }
    //             }
    //         }, [title, h("DropdownMenu", { slot: "list" }, DropdownItem)])
    //     }
    //     return renderBtn
    // },

    // 生成操作
    // renderOperate(h, btn) {
    //   const renderBtn = [];
    //   if (btn instanceof Array) {
    //     btn.forEach((item) => {
    //       let { title } = item;

    //       if (title instanceof Function) {
    //         title = title();
    //       }
    //       renderBtn.push(h(
    //         'span',
    //         {
    //           on: item.on,
    //           style: {
    //             color: '#89a',
    //             cursor: 'pointer',
    //             marginRight: '10px',
    //             whiteSpace: 'nowrap',
    //           },
    //         },
    //         title,
    //       ));
        
    //     });
    //   }
    //   return renderBtn;
    // },
  
  },
  filters: {
    passFormat(value) {
      if (value) {
        let pass = '';
        const { length } = value;
        let len = 1;
        if (length > 6) {
          len = 3;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 4) {
          len = 2;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 2) {
          len = 1;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 1) {
          len = 1;
          pass = `${value.substr(0, len) }*`;
        } else {
          pass = value;
        }
        return pass;
      } else {
        return value;
      }
    },
    moneyFix(value) {
      const number = (`${value }`).replace(/[^0-9+-Ee.]/g, '');
      const n = !isFinite(+number) ? 0 : +number;
      const prec = 2;
      const sep = ',';
      let s = '';
      const toFixedFix = function (num, pre) {
        const k = Math.pow(10, pre);
        return `${ Math.round(num * k) / k}`;
      };

      s = (prec ? toFixedFix(n, prec) : `${ Math.round(n)}`).split('.');
      const re = /(-?\d+)(\d{3})/;
      // while (re.test(s[0])) {
      //   s[0] = s[0].replace(re, `$1${ sep }$2`);
      // }

      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join('.');
    },
  },
};
